import { View } from 'react-native'

import { colors } from '../../theme'
import { Spinner } from './Spinner'

type WebPullToRefreshIndicatorProps = {
  enabled: boolean
  pullDistance: number
  refreshing: boolean
  shouldRelease: boolean
  color?: string
}

export function WebPullToRefreshIndicator({
  enabled,
  pullDistance,
  refreshing,
  shouldRelease,
  color,
}: WebPullToRefreshIndicatorProps) {
  if (!enabled || (!refreshing && pullDistance <= 0)) {
    return null
  }

  const progress = Math.min(1, pullDistance / 72)
  const height = refreshing
    ? 34
    : Math.max(16, Math.min(44, Math.round(pullDistance * 0.45)))
  const scale = refreshing ? 1 : 0.72 + progress * 0.28
  const opacity = refreshing ? 1 : 0.45 + progress * 0.55

  return (
    <View
      className="items-center justify-center"
      style={{
        height,
        marginBottom: 24,
        transform: [{ scale: shouldRelease ? 1 : scale }],
        opacity,
        pointerEvents: 'none',
      }}
    >
      <Spinner size="small" color={color ?? colors.primary} />
    </View>
  )
}
